import $ from 'wee-dom';

export default () => {
    return `<div class="newsletter -response" data-ref="newsletterResponse">
    <div class="newsletter__icon"><span class="sr-only">Success</span></div>
    <h2 class="newsletter__title -success">Thank you for signing up!</h2>
    <p class="newsletter__copy">We’ve recieved your email and will be in touch.</p>
    </div>`
}